import type { LessonCourse } from "../lessons/schema.ts";
import { walkRepertoire } from "../lessons/coverage.ts";

export type TrainingPrompt = { cue: string; goal?: string; contrast?: string };
export type BranchTeaching = {
  match: string;
  idea: string;
  contrast: string;
  question?: { prompt: string; choices: string[]; answer: number; explanation: string };
};
export type TrainingContent = { mainline: TrainingPrompt[]; branches: BranchTeaching[] };
const content = new Map<string, TrainingContent>();
const positions = new WeakMap<LessonCourse, Map<string, TrainingPrompt>>();

/** Training prose travels with a practice visit, never with the openings menu. */
export async function loadTrainingContent(id: string): Promise<void> {
  if (content.has(id)) return;
  const loaders: Record<string, () => Promise<{ default: TrainingContent }>> = {
    italian: () => import("./prompts/italian.ts"),
    caroKann: () => import("./prompts/caroKann.ts"),
    ruyLopez: () => import("./prompts/ruyLopez.ts"),
    qgdBlack: () => import("./prompts/qgdBlack.ts"),
  };
  if (loaders[id]) content.set(id, (await loaders[id]()).default);
}

export function trainingPrompt(course: LessonCourse, key: string): TrainingPrompt | null {
  const pack = content.get(course.openingId);
  if (!pack) return null;
  let map = positions.get(course);
  if (!map) {
    map = new Map();
    const nodes = walkRepertoire(course).nodes.filter(
      (n) => n.fen.split(" ")[1] === (course.side === "white" ? "w" : "b")
    );
    nodes.forEach((node, i) => {
      if (pack.mainline[i]) map!.set(node.positionKey, pack.mainline[i]);
    });
    positions.set(course, map);
  }
  return map.get(key) || null;
}

export function branchTeaching(id: string, name: string): BranchTeaching | null {
  return (
    content
      .get(id)
      ?.branches.find((branch) => name.toLowerCase().includes(branch.match.toLowerCase())) || null
  );
}
